<template>
  <div class="fast-buy-menu">
    <div class="right-menu__title">
      <h4>Оформить заявку</h4>
    </div>
    <p class="right-menu__text">
      Оставьте номер телефона, менеджер по акции свяжется с вами
    </p>
    <div class="t-form marginBottom">
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.name }">
          <input
            type="text"
            id="fast-buy-name"
            v-model="data.name"
            @click="() => clearError('name')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.name }"
            for="fast-buy-name"
          >
            ФИО
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.nameText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.phone }">
          <input
            type="text"
            id="fast-buy-phone"
            @input="phoneFormat"
            :value="data.phone"
            maxlength="17"
            @click="() => clearError('phone')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.phone }"
            for="fast-buy-phone"
          >
            Номер телефона
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.phoneText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.address }">
          <input
            type="text"
            id="fast-buy-address"
            v-model="data.address"
            @click="() => clearError('address')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: data.address }"
            for="fast-buy-address"
          >
            Адрес доставки
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.addressText }}</span>
        </div>
      </div>
      <div class="t-form__row">
        <div class="t-form__input" :class="{ error: errors.message }">
          <textarea
            id="fast-buy-message"
            rows="5"
            v-model="message"
            @click="() => clearError('message')"
          />
          <label
            class="t-form__input-placeholder"
            :class="{ active: fastbuymessage }"
            for="fast-buy-message"
          >
            Комментарий к заказу
            <span>*</span>
          </label>
          <span class="t-form__input-error">{{ errors.messageText }}</span>
        </div>
      </div>
    </div>
    <p class="right-menu__text">
      Нажимая кнопку отправить, вы принимаете условия обработки персональных
      данных
    </p>
    <t-button type="small blue uppercase" :callback="submit"
      >Отправить заявку</t-button
    >
  </div>
</template>

<script>
import Button from '@components/ui/button.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import Inputmask from 'inputmask';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';

export default {
  components: {
    't-button': Button,
  },
  data: function() {
    return {
      data: {
        name: '',
        phone: '',
        address: '',
      },
      errors: {
        name: false,
        nameText: '',
        phone: false,
        phoneText: '',
        address: false,
        addressText: '',
        message: false,
        messageText: '',
      },
      errorsText: {
        empty: 'Поле не должно быть пустым',
        shortPassword: 'Пароль должен быть 6 и более символов',
        mismatchPassword: 'Введеные пароли не совпадают',
        incorrectPassword: 'Неверный пароль',
        incorrectUser: 'Пользователя с таким телефоном не существует',
      },
    };
  },
  computed: {
    ...mapState('params', ['fastbuymessage', 'fastbuymessageId']),
    ...mapState('api', ['quickOrder']),

    message: {
      get: function() {
        return this.fastbuymessage;
      },

      set: function(newValue) {
        this.setFastBuymessage({ value: newValue });
      },
    },
  },
  methods: {
    ...mapMutations('params', [
      'toggleFastbuy',
      'toogleConfirmBlock',
      'setFastBuymessage',
    ]),
    ...mapActions('api', ['fetchRequest']),
    phoneFormat: function({ target }) {
      this.data.phone = setPhoneFormat(target.value);
    },
    createPhone: function(value) {
      return resetPhoneFormat(value).slice(1);
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    validation: function() {
      let error = false;

      Object.keys(this.data).forEach((item) => {
        if (!this.data[item].trim()) {
          this.setErrors(item, 'empty');
        }
      });

      if (!this.message.trim()) {
        this.setErrors('message', 'empty');
      }

      return error;
    },
    setErrors: function(id, error) {
      this.errors[id] = true;
      this.errors[id + 'Text'] = this.errorsText[error];
    },

    clearError: function(id) {
      this.errors[id] = false;
    },

    submit: function() {
      if (this.validation()) return;

      this.fetchRequest({
        url: this.quickOrder,
        form: this.fastbuymessageId
          ? this.form({
              ...this.data,
              phone: this.createPhone(this.data.phone),
              message: this.message,
              saleId: this.fastbuymessageId,
            })
          : this.form({
              ...this.data,
              phone: this.createPhone(this.data.phone),
              message: this.message,
            }),
        success: (data) => {
          console.log('success', data);
          if (data.body.success) {
            this.toggleRightMenu();
            this.toggleFastbuy();
          }
        },
        error: (e) => {
          console.log('error', e);
        },
      });
      this.toggleFastbuy();
      this.toogleConfirmBlock({
        title: 'Ваш заказ принят',
        text: 'Наш менеджер скоро свяжется с вами',
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.marginBottom
  margin-bottom: 32px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/fastbuy.vue